<template>
    <div>
    <!-- add after this -->

    <!-- start breadbrumbs -->
		<div class="mt-4 mb-4">
			<nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/interhom/">Home</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/default.stm">Sustainability</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/building-energy-disclosure.stm">Building Energy Disclosure Project</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Registration</li>                   
                </ol>
			</nav>
		</div>
		<!-- end breadbrumbs -->
		<div class="row">
			<main class="col-12 col-lg-9">
                <div class="cw-content-nosidenav">
                    <h1>Registration</h1>

                    <ParticipationAgreement />
                    <!-- ***** start custom content ***** -->

                    <div class="custom-control custom-checkbox mt-4">
                        <input type="checkbox" v-model="signAgreement" value="true" class="custom-control-input" id="customCheck1" :disabled="fromLink" />
                        <label class="custom-control-label" for="customCheck1">Agree</label>
                    </div>
                    <div class="row mt-5" v-if="!fromLink">
                        <div class="col">
                            <button type="button" class="btn btn-outline-secondary" @click="prevpage">Previous page</button>
                        </div>
                        <div class="col-auto">
                            <button type="button" :disabled="!signAgreement" class="btn btn-primary float-right" @click="nextpage">{{buttonLabel}}</button>
                        </div>
                    </div>
                </div>
			</main>
		</div>

    <!-- add before this -->
    </div>
</template>

<script>
    import ParticipationAgreement from '@/components/Wording/ParticipationAgreement';

    export default {
        name: 'signagreement',
        components: {
            ParticipationAgreement
        },
        data: function () {
            return {
                signDate: new Date().toISOString().slice(0,10),
                signAgreement: false,
                buttonLabel: "Next",
            }
        },
        created() {

            const data = (this.$route.params.data)
                ? JSON.parse(atob(this.$route.params.data))
                : this.$store.getters.PARTICIPATIONAGREEMENT;
            
            if (data.length > 0) {
                const item = data[0];

                this.signAgreement = item.signAgreement;
            }
        },

        computed: {
            fromLink() {
                return (this.$route.params.data !== undefined);
            },
        },
        mounted() {
            let data = this.$store.getters.PARTICIPATIONAGREEMENT;
            if (data.length > 0) {
                let item = data[0];

                this.signAgreement = item.signAgreement;
            }
        },
        methods: {
            nextpage() {
                let nextPage = "Account";

                let summaryPage = this.$store.getters.SUMMARYPAGE;
                if (summaryPage)
                    nextPage = "Summary";

                let p = this.$store.getters.PARTICIPANT;
                
                let value = {
                    signAgreement: this.signAgreement,
                    signDate: this.signDate,
                    participantName: p.participantName,
                    fullName: p.fullName,
                    jobTitle: p.jobTitle,
                    address: p.address,
                    phone: p.phone,
                    email: p.email
                };

                this.$store.dispatch("SAVE_PARTICIPATIONAGREEMENT", value);

                //this.$router.push({ name: 'Detail', params: { parameters: this.contactList } });
                this.$router.push({ name: nextPage });
            },
            prevpage() {
                let nextPage = "Home";

                this.$router.push({ name: nextPage });
            }
        }
    }
</script>